<template>
  <div class='h100vh-140'>
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <e-items>
          <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("System.createGroupInfo")' :click="showCreateGroup"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("System.change")' :click="showEditGroup"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("System.delete")' :click="showDelGroup"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click="getGroupList"></e-item>
        </e-items>
      </ejs-toolbar>
      <div class="h-inputBox">
        <ejs-textbox class="e-input" :placeholder='$t("System.userGroupName")' @keyup.enter.native="getGroupList" v-model="groupKey" />
      </div>
    </div>
    <div class="h100-40 h-scroll">
      <ejs-grid ref="grid" height='calc(100vh - 280px)' :allowPaging="true" :pageSettings="pageSettings">
        <e-columns>
          <e-column field="groupName" :headerText='$t("System.userGroupName")' width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="describe" :headerText='$t("System.description")' width="150" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref="pager" :pageSize="pageSettings.pageSize" :pageCount="pageCount" @click="getGroupList"></ejs-pager>
    </div>
    <CustomDialog ref="createGroupDialog" v-bind:element="createGroupDialog.element" v-bind:styles="createGroupDialog.styles">
      <template v-slot:dialog-content>
        <CreateGroup ref="createGroup" v-bind:editParams="editParams" v-bind:optionalParams="optionalParams" v-bind:selectedParams="selectedParams" @childProps="getGroupMessage"></CreateGroup>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "../common/CustomDialog";
import CreateGroup from "../system/CreateGroup";
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "AddressGroup",
  data() {
    return {
      optionalParams: [],
      selectedParams: [],
      pageSettings: { pageSize: 25 },
      pageCount: "4",
      groupProps: {},
      pageNo: "1",
      editParams: {},
      createOrEdit: 0,
      createGroupDialog: {
        element: {
          target: "#app",
          isClose: true,
          refName: "createGroup",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('System.cancel')}` }
            },
            {
              click: this.confirmGroup,
              buttonModel: { content: `${this.$t('System.confirm')}`, cssClass:"primary-btn"}
            }
          ],
          title: `${this.$t('System.createGroupInfo')}`
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      groupKey: ""
    };
  },
  components: {
    CustomDialog,
    CreateGroup
  },
  methods: {
    showCreateGroup() {
      this.createOrEdit = 0;
      this.getOptionalUserList();
      this.$refs.createGroupDialog.show();
      this.$refs.createGroup.bindValidate();
    },
    showEditGroup() {
      const record = this.getRecord();
      if (record == null) {
        return null;
      }
      this.createOrEdit = 1;
      const url = "/lte/ems/sysmanager/user/getPitchUser";
      const params = record[0];
      this.editParams = this.copyDeep(params);
      this.axios.get(url, { params }).then(response => {
        this.selectedParams = [];
        const result = response.data;
        result.forEach(e => {
          this.selectedParams.push({ name: e });
        });
        this.getOptionalUserList();
        this.$refs.createGroupDialog.show();
        this.$refs.createGroup.bindValidate();
      });
    },
    showDelGroup() {
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      this.$layer.confirm({
        msg: this.$t('System.confirmDel'),
        btn1: {
          msg: this.$t('System.cancel'),
        },
        btn2: {
          msg: this.$t('System.confirm'),
          func: this.delGroup
        }
      });
    },
    dialogHide() {
      this.$refs.createGroupDialog.clear();
      this.$refs.createGroupDialog.close();
    },
    getRecord() {
      let record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record == "") {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectOneMessage')});
        return null;
      }
      return record;
    },
    confirmGroup() {
      //新增和编辑
      if (!this.$refs.createGroup.validate()) {
        return null;
      }
      this.$refs.createGroupDialog.clear();
      this.$refs.createGroupDialog.close();
      if (this.createOrEdit === 0) {
        this.checkGroupExist();
      } else {
        this.addGroup("/lte/ems/sysmanager/user/updateGroupWithEdit");
      }
    },
    checkGroupExist() {
      const url = '/lte/ems/sysmanager/user/groupVerify';
      const params = this.groupProps;
      this.axios.get(url, { params }).then(response => {
        if (response.data) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.groupExists')});
        } else {
          this.addGroup("/lte/ems/sysmanager/user/saveGroupData");
        }
      });
    },
    addGroup(dUrl) {
      const url = dUrl;
      const params = this.groupProps;
      this.axios.post(url, params).then(response => {
        if (response.data) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
          this.saveUserAndGroup();
        }else{
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
      });
    },
    saveUserAndGroup() {
      const url = "/lte/ems/sysmanager/user/saveUserAndGroupData";
      const user = [];
      this.groupProps.selectedUser.forEach(e => {
        user.push(e.name);
      });
      const params = { groupName: this.groupProps.groupName, userName: user };
      this.axios.post(url, params).then(response => {
        this.getGroupList();
      });
    },
    getGroupMessage(data) {
      this.groupProps = data;
      console.log(this.groupProps);
    },
    getGroupList() {
      const url = "/lte/ems/sysmanager/user/getGroupData";
      this.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        keyString: this.groupKey,
        pageNo: this.pageNo,
        pageSize: this.pageSettings.pageSize
      };
      this.axios.get(url, { params }).then(response => {
        this.$refs.grid.ej2Instances.dataSource = response.data.result;
        this.$refs.pager.ej2Instances.totalRecordsCount =
          response.data.totalCount;
      });
    },
    getOptionalUserList() {
      const url = "/lte/ems/sysmanager/user/getUserData";
      this.axios.get(url).then(response => {
        this.optionalParams = response.data.result;
      });
    },
    delGroup() {
      const url = "/lte/ems/sysmanager/user/deleteGroupData";
      const record = this.getRecord();
      const params = record[0];
      this.axios.get(url, { params }).then(response => {
        this.getGroupList();
        if (response.data) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
        } else {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.failure')});
        }
      });
    },
    copyDeep(data) {
      let returnData = JSON.parse(JSON.stringify(data));
      return returnData;
    }
  },
};
</script>
